<app-dialog-container
    [loading]="false"
    (closeEvent)="closeDialog()"
    [title]="'Save Report'"
    data-cy="save-report-dialog-container"
>
    <div *ngIf="!allFiltersSelected && !isEditMode">
        <p class="margin-bottom-1-em bold-font">Please make sure all required fields have been selected.</p>
    </div>
    <div class="is-flex is-flex-direction-column">
        <div
            class="ra-primary-blue has-text-centered label-wrapper"
            *ngIf="allFiltersSelected && !isEditMode"
        >
            <label class="has-text-weight-semibold">Create New Saved Report</label>
        </div>
        <p
            *ngIf="isEditMode"
            class="margin-bottom-1-em bold-font"
        >
            Edit Report
        </p>
        <div
            *ngIf="allFiltersSelected && !isEditMode"
            class="flex-container margin-top-75-em"
        >
            <app-filter-input
                [property]="filters.nameFilter"
                class="report-name"
                [appearance]="'outline'"
            >
            </app-filter-input>
        </div>
        <app-filter-input
            *ngIf="isEditMode"
            [property]="filters.nameFilter"
        ></app-filter-input>

        <app-filter-input [property]="filters.saveAsGlobalFilter"></app-filter-input>
        <app-filter-input
            *ngIf="showSaveMetricSelections"
            [property]="filters.saveMetricSelectionsFilter"
            data-cy="save-metric-selections-toggle"
        ></app-filter-input>
        <app-filter-input
            [property]="filters.addAsFavoriteFilter"
            *ngIf="allFiltersSelected && !isEditMode"
        ></app-filter-input>

        <div>
            <p
                class="bold-font"
                *ngIf="filters.dateRangeOptionsFilter && !filters.politicalDateLabel"
            >
                Date Range Options
            </p>
            <p
                class="bold-font"
                *ngIf="filters.politicalDateLabel"
            >
                Date Range:
            </p>
            <p *ngIf="filters.politicalDateLabel">{{ filters.politicalDateLabel }}</p>
        </div>
        <app-filter-input
            *ngIf="filters.dateRangeOptionsFilter"
            [property]="filters.dateRangeOptionsFilter"
        ></app-filter-input>

        <app-filter-input
            *ngIf="isEditMode"
            [hidden]="filters.dateRangeOptionsFilter.Value?.name !== 'Save Fixed Dates'"
            [property]="filters.startDateSelectFilter"
        ></app-filter-input>
        <app-filter-input
            *ngIf="isEditMode"
            [hidden]="filters.dateRangeOptionsFilter.Value?.name !== 'Save Fixed Dates'"
            [property]="filters.endDateSelectFilter"
        ></app-filter-input>

        <app-filter-input
            *ngIf="filters.dateRangeOptionsFilter"
            [hidden]="!isRollingPeriodsSelected() || filters.periodSelectFilter.hide"
            [property]="filters.periodSelectFilter"
        ></app-filter-input>
        <app-filter-input
            *ngIf="filters.dateRangeOptionsFilter"
            [hidden]="!isRollingPeriodsSelected()"
            [property]="filters.startingPeriodFilter"
        ></app-filter-input>
        <app-filter-input
            *ngIf="filters.dateRangeOptionsFilter"
            [hidden]="!isRollingPeriodsSelected()"
            [property]="filters.numberOfPeriodsFilter"
        ></app-filter-input>

        <app-filter-input
            *ngIf="filters.dateRangeOptionsFilter"
            [hidden]="filters.dateRangeOptionsFilter.Value.name !== 'Quick Date Options'"
            [property]="filters.quickDateOptionsSelectFilter"
        ></app-filter-input>

        <div class="level-right">
            <app-button
                *ngIf="isEditMode"
                [buttonText]="'Cancel'"
                (buttonClick)="closeDialog()"
                [type]="'stroked'"
            />
            <app-button
                *ngIf="isEditMode"
                [buttonText]="'Save Changes'"
                (buttonClick)="close()"
                [type]="'flat'"
            />
            <app-button
                *ngIf="!isEditMode"
                [class]="'width-100-pct'"
                [buttonText]="'Save'"
                (buttonClick)="close()"
                [type]="'flat'"
                [disabled]="!filters.nameFilter.isValid ? 'true' : null"
            />
        </div>
    </div>
</app-dialog-container>
